import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e9c62acc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9c62acc')) {
      api.createRecord('e9c62acc', component.options)
    } else {
      api.reload('e9c62acc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e9c62acc&", function () {
      api.rerender('e9c62acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/pricehelp.vue"
export default component.exports